import React from 'react';
import PropTypes from 'prop-types';

const EndSection = props => {
    const { children, className, 'data-testid': dataTestId } = props;
    return (
        <div className={`bookmark justify-content-end ${className || ''}`.trim()} data-testid={dataTestId || undefined}>
            {children}
        </div>
    );
};

EndSection.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    'data-testid': PropTypes.string,
};

EndSection.defaultProps = {
    className: '',
    children: null,
    'data-testid': null,
};

export default EndSection;
